module.exports = __webpack_public_path__ + "img/mcl1.bfdcca49.jpg";